import { useMemo } from 'react';
import PropTypes from 'prop-types';

import useDetailTable from '#/hooks/table/useDetailTable';
import DetailTable from '#/modules/commonComponents/table/DetailTable';
import {
  mapSalesOrderAllocationBrowseRows,
} from '#/modules/crmMgmt/salesOrder/helper/mapSalesOrderAllocationBrowseRows';
import { formatDisplayQty } from '#/utils/formatNumber';

function buildAllocationColumns() {
  return [
    {
      id: 'product',
      header: '產品',
      accessorFn: (row) => row.productLabel,
      size: 200,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
    },
    {
      id: 'material',
      header: '物料',
      accessorFn: (row) => row.materialLabel,
      size: 200,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
    },
    {
      id: 'stockNo',
      header: '庫存編號',
      accessorFn: (row) => row.stockNo,
      size: 150,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
    },
    {
      id: 'warehouse',
      header: '倉庫',
      accessorFn: (row) => row.warehouseLabel,
      size: 140,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
    },
    {
      id: 'qty',
      header: '數量',
      accessorFn: (row) => formatDisplayQty(row.qty),
      size: 96,
      enableSorting: false,
      meta: { cellClassName: 'td_right' },
    },
  ];
}

/**
 * 銷貨單詳情「使用庫存」：扁平 detail.lines[].invAllocations（不另打 API）。
 */
const SalesOrderAllocationsReadonlySection = ({ lines = [] }) => {
  const columns = useMemo(() => buildAllocationColumns(), []);
  const rows = useMemo(
    () => mapSalesOrderAllocationBrowseRows(lines),
    [lines],
  );

  const detailTableState = useDetailTable(rows, columns, {
    enableExpanding: false,
    getRowId: (row, index) => String(row.id ?? `alloc-${index}`),
  });

  if (rows.length === 0) {
    return (
      <div className="px-4 py-5">
        <p className="text-xs text-muted-foreground">本單已配置的庫存一覽。</p>
        <p className="mt-3 text-sm text-muted-foreground">尚無使用庫存</p>
      </div>
    );
  }

  return (
    <div className="px-4 py-4">
      <p className="mb-3 text-xs text-muted-foreground">本單已配置的庫存一覽。</p>
      <div className="detail-table-container">
        <DetailTable
          state={detailTableState}
          containerClassName="detail-table-scroll--section-embedded"
          tableClassName="detail-table--flat-lines"
        />
      </div>
    </div>
  );
};

SalesOrderAllocationsReadonlySection.propTypes = {
  lines: PropTypes.arrayOf(PropTypes.object),
};

export default SalesOrderAllocationsReadonlySection;
